import { useEffect, useState } from 'react';

import {
  getOnboardingUrl,
  ONBOARDING_RN_FLAG,
  ONBOARDING_RN_VARIANT,
} from '../config/runtimeConfig';
import { analytics } from '../utils/analytics';
import { EXTERNAL_URLS, ONBOARDING_RN_PATH } from '../utils/constants';

/**
 * Returns the URL the "Sign up" link in AuthFooter should point to.
 *
 * Pre-login surface — flag is evaluated against PostHog's anonymous device ID,
 * not a logged-in distinct_id. Defaults to the legacy sparta URL while the
 * flag resolves so the link is never broken on initial render.
 *
 * `onboardingUrl` config short-circuits both the default and the flag lookup
 * — skips the PostHog evaluation entirely when a host has already told us
 * which URL to use (VRN native, local dev).
 */
export const useOnboardingSignupUrl = (): string => {
  const override = getOnboardingUrl();
  const [url, setUrl] = useState<string>(override ?? EXTERNAL_URLS.ONBOARDING);

  useEffect(() => {
    if (override) return;
    let cancelled = false;
    analytics.getFeatureFlag(ONBOARDING_RN_FLAG).then((variant) => {
      if (!cancelled && variant === ONBOARDING_RN_VARIANT) setUrl(ONBOARDING_RN_PATH);
    });
    return () => {
      cancelled = true;
    };
  }, [override]);

  return url;
};
